import React, { useEffect } from "react";
import ReactDOM from 'react-dom';
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import $ from "jquery"; // Import jQuery
import CustomNeed from "../component/CustomNeed";

const LogoCollateralDesign = () => {
    useEffect(() => {
    
        const win = window;
    
        function isElementVisible($el) {
          const viewTop = win.scrollY;
          const viewBottom = viewTop + window.innerHeight;
          const elTop = $el.offset().top;
          const elBottom = elTop + $el.height();
          return elBottom <= viewBottom && elTop >= viewTop;
        }
        $('.why_coustom_app').parents('body').find('header').addClass('white_header');  
        function addAnimation($el, delay) {
            
          setTimeout(() => {
            $el.addClass("come-in");
            $el.attr("class", "webflow_circle come-in");
          }, delay);
        }
    
        const allMods1 = Array.from(document.querySelectorAll(".webflow_circle"));
        const allMods2 = Array.from(document.querySelectorAll(".html_circle"));
        const allMods3 = Array.from(document.querySelectorAll(".css_circle"));
        const allMods4 = Array.from(document.querySelectorAll(".js_circle"));
    
        win.addEventListener("scroll", () => {
          allMods1.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods2.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods3.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
    
          allMods4.forEach((el, i) => {
            const $el = $(el);
            if (isElementVisible($el)) {
              addAnimation($el, i * 200);
            }
          });
        });
    
        const handleScroll = () => {
          const offset = window.pageYOffset;
          const wheight = window.innerHeight;
          const html = document.documentElement;
          const docheight = Math.max(
            document.body.scrollHeight,
            document.body.offsetHeight,
            html.clientHeight,
            html.scrollHeight,
            html.offsetHeight
          );
          let progress = (offset / (docheight - wheight)) * 3000;
    
          // Give the line a CSS gradient based on scroll position
          progress = 3000 - progress * 1.6;
    
          // Update the SVG element with the new stroke-dashoffset
          const fillingPath = document.getElementById("filling_path");
          if (fillingPath) {
            fillingPath.setAttribute("stroke-dashoffset", progress);
          }
        };
    
        // Add scroll event listener when the component mounts
        window.addEventListener("scroll", handleScroll);
    
        // Remove the event listener when the component unmounts
        return () => {
            
          window.removeEventListener("scroll", handleScroll); 
        };
      }, []);
      const [ref, inView] = useInView({
        triggerOnce: true, // Ensures the animation occurs only once
        threshold: 0.2, // Change as needed; it's the percentage of the element's visibility to trigger the animation
      });
    
      const leftAnimation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut" }, // Define your desired animation properties
        },
      };
    
      const image1Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 0.5 }, // Define your desired animation properties
        },
      };
    
      const image2Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1 }, // Define your desired animation properties
        },
      };
    
      const image3Animation = {
        hidden: { opacity: 0, scale: 0, x: -200 },
        visible: {
          opacity: 1,
          scale: 1,
          x: 0,
          transition: { duration: 1, ease: "easeOut", delay: 1.5 }, // Define your desired animation properties
        },
      };
       
      return (
        <>
          <div
            className="inner_banner service-banner"
            style={{ backgroundImage: "url(/assets/images/site/dedicated-dev-2.png)" }}
          >
            <div className="wrapper">
              <div className="banner_detail_1">
                <div className="details-ser">
                    <h1 id="heading_line">Creating a Lasting Impression: The Importance of Logo & Collateral Design for Your Brand</h1>
                    <h2 id="sub_heading1">
                    In today's competitive business landscape, your brand’s identity plays a pivotal role in how customers perceive and interact with your company. One of the most crucial elements of your brand's identity is your logo. It’s the first thing people notice about your business and serves as a visual representation of your values, mission, and products. However, creating a memorable logo is just the beginning. Complementary collateral design, such as business cards, brochures, and packaging, reinforces your brand and ensures consistency across all touchpoints.
                    </h2>                                    
                </div>
              </div>
            </div>
            </div>
            <div className="why_coustom_app">
                <div className="wrapper">
                <h3>What is <span>Logo Design ?</span> </h3>
                    <p>Logo design refers to the process of creating a distinctive symbol or graphic that represents your brand. A good logo is simple, memorable, versatile, and relevant to your business. It should communicate your company’s identity and leave a lasting impression on potential customers.</p>

                    <h3>Key Elements of Effective<span> Logo Design:</span></h3>
                    <h4>1.	Simplicity</h4>
                    <p> The most iconic logos are simple and easily recognizable. Think of brands like Nike or Apple—their logos are clean, minimal, and powerful. A simple design is easier to remember and works across various platforms and sizes.</p>
                    <h4>2.	Relevance</h4>
                    <p> A logo should align with your industry and target audience. For example, a tech company may opt for a sleek, modern logo, while a children’s toy company may prefer a playful, colorful design.</p>
                    <h4>3.	Versatility</h4>
                    <p>Your logo should work in various applications—whether on a website, social media profile, business card, or billboard. It should look great in black and white, as well as in full color.</p>
                    <h4>4.	Timelessness</h4>
                    <p>Aim for a logo that doesn’t just reflect current trends but has lasting power. A timeless logo helps build long-term brand recognition.</p>
                    <h3>The Role of Collateral<span> Design in Branding</span></h3>
                    <p>Collateral design refers to the creation of printed or digital materials that help communicate your brand’s message. This includes brochures, flyers, business cards, letterheads, social media graphics, presentations, packaging, and more. Your collateral should complement your logo and communicate your brand’s identity in a consistent, cohesive manner.</p>
                    <h4>Types of Collateral Design:</h4>
                    <h4>1.	Business Cards</h4>
                    <p>Your business card is often the first physical interaction someone will have with your brand. A well-designed card reflects professionalism and reinforces your identity. Ensure your logo is prominently displayed and includes essential contact information.</p>
                    <h4>2.	Brochures & Flyers</h4>
                    <p>Brochures and flyers are excellent marketing tools that allow you to showcase your products or services in a visually appealing way. Incorporating your logo and consistent branding elements will make these materials more impactful and engaging.</p>
                    <h4>3.	Packaging Design</h4>
                    <p>Packaging is one of the most direct ways customers experience your brand. Thoughtful packaging design not only protects the product but also serves as an extension of your brand’s identity. Unique, eye-catching packaging can help you stand out on the shelf and encourage customer loyalty.</p>
                    <h4>4.	Social Media Graphics</h4>
                    <p> Social media is a crucial channel for brand visibility. Consistent collateral design across your social media platforms—using your logo and brand colors—helps establish a cohesive online presence.</p>
                    <h4>5.	Letterheads & Presentation Templates</h4>
                    <p> For formal communications, letterheads, and branded presentation templates, ensure your logo is prominent and your design language matches the tone of your business.</p>
                    <h3>The Importance of Consistency in Logo &<span> Collateral Design</span></h3>
                    <p>Consistency is the cornerstone of effective branding. Your logo and collateral should always work together to create a unified look across all touchpoints. This consistency builds recognition and trust with your audience. When customers encounter your brand on your website, social media, packaging, or in-store, they should instantly recognize it as the same brand they’ve interacted with before.</p>
                    <h4>1.	Increases Brand Recognition</h4>
                    <p>A cohesive brand image makes it easier for your audience to recognize you. Repeated exposure to consistent visuals helps form stronger brand associations in the consumer's mind.</p>
                    <h4>2.	Builds Trust and Credibility</h4>
                    <p>Consistency across all branding elements conveys professionalism and reliability. When your collateral aligns with your logo and overall branding, it sends a message of quality and attention to detail.</p>
                    <h4>3.	Enhances Customer Experience</h4>
                    <p> When every interaction with your brand feels seamless, it creates a more positive experience for the customer. Whether they’re reading your brochure, visiting your website, or interacting with your product, the design should feel connected and cohesive.</p>
                    <h3>Tips for Creating Effective <span>Logo & Collateral Designs:</span></h3>
                    <h4>Logo & Collateral Designs:</h4>
                    <p> Logo and collateral design is an investment in your brand’s future. Hiring a professional designer ensures that your logo is properly crafted and your collateral looks polished. Experienced designers understand how to create cohesive, visually appealing designs that align with your business goals.</p>
                    <h4>2.	Stay True to Your Brand’s Values</h4>
                    <p>Your logo and collateral should reflect the essence of your brand. Whether you’re a fun, creative startup or a serious, corporate entity, your design choices should align with your business’s personality and values.</p>
                    <h4>3.	Keep Your Target Audience in Mind</h4>
                    <p>Understand who you’re designing for. Your logo and collateral should appeal to your target demographic. Consider their preferences, lifestyle, and needs when designing your brand materials.</p>
                    <h4>4.	Ensure Scalability</h4>
                    <p> Whether your logo is displayed on a small business card or a large billboard, it should maintain its integrity. Work with a designer who creates scalable, vector-based logos that will look great in any size.</p>
                    <h3><span>Conclusion</span></h3>
                    <p>A thoughtfully designed logo and complementary collateral materials are vital to establishing and growing your brand. A logo serves as the face of your brand, while your collateral extends that identity into every interaction. By prioritizing consistency, simplicity, and relevance, you can create a cohesive brand experience that resonates with your audience and stands the test of time.</p>
                </div>
            </div>
            <div className="why_us">
            <div className="wrapper">
              <h4>Benefits of Working with CodeFlix</h4>
              <div className="col_row">
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg1.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us5.svg" alt="" />
                  </div>
                  <hr />
                  <h3>End-to-End Solutions</h3>
                  <p>
                    From ideation to deployment, we handle every aspect of the
                    development process.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg2.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us6.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Agile Methodology</h3>
                  <p>
                    Ensuring flexibility and faster delivery without compromising on
                    quality.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg3.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us7.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Experienced Team</h3>
                  <p>
                    A skilled team of developers, designers, and project managers
                    dedicated to your success.
                  </p>
                </div>
                <div
                  className="col_item"
                  style={{
                    backgroundImage: `url(./assets/images/portfolio/usbg4.svg)`,
                  }}
                >
                  <div className="icon">
                    <img src="./assets/images/portfolio/us8.svg" alt="" />
                  </div>
                  <hr />
                  <h3>Client-Centric Approach</h3>
                  <p>
                    Regular communication and collaboration to align the project
                    with your vision.
                  </p>
                </div>
              </div>
           <br />
            </div>
            </div>
            <div className="let_build">
                <div className="wrapper">
                <h4>Let’s Build <span> Your App Together </span></h4>
                
                <p>
                Whether you’re a startup looking to disrupt the market or an
                established enterprise aiming to enhance operational efficiency,
                CodeFlix is here to bring your vision to life. Let’s create a
                custom mobile app that drives results and delights your users.{" "}
                <br />
                Contact Us today to get started on your mobile app development
                journey.
                </p>
                </div>
            </div>
        </>
      );
};
export default LogoCollateralDesign;
